<template>
  <div class="rentalObjectTenancies">
    <h2 class="mb-5">{{ defaultHeader }}</h2>

    <Tenancies
      v-if="tenancies && tenancies.length > 0"
      :tenancies="tenancies"
      :shouldShowRentalObject="false"
      :shouldShowSubButton="false"
    />

    <EmptyStates
      v-else
      :hasLandlordNoRentalObject="false"
      :hasLandlordNoTenancy="true"
      :rentalObjectIdProp="parseInt(rentalObjectId)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EmptyStates from '@/components/EmptyStates.vue';
import Tenancies from '@/components/Tenancies.vue';

export default {
  props: {
    rentalObjectId: [Number, String],
    defaultHeader: String,
  },
  components: {
    EmptyStates,
    Tenancies,
  },
  computed: {
    ...mapGetters(['getRentalObjectTenancies']),

    tenancies() {
      return this.getRentalObjectTenancies(this.rentalObjectId);
    },
  },
};
</script>
